import { toast } from "@/hooks/use-toast";

const MAX_NAMED = 5;

/**
 * AUT-220: the Global list takes precedence, so brand/product adds silently drop
 * keywords it already blocks. This says which ones, so a caller who pasted 50
 * keywords and saw 48 stored knows why the other two are missing.
 */
export function notifySkippedByGlobal(keywords: string[] | undefined, tierLabel: "Brand" | "Product") {
  if (!keywords?.length) return;

  const named = keywords.slice(0, MAX_NAMED).map((k) => `"${k}"`).join(", ");
  const rest = keywords.length - MAX_NAMED;
  const list = rest > 0 ? `${named} and ${rest} more` : named;
  const singular = keywords.length === 1;

  toast({
    title: "Already in Global Prohibited Keywords",
    description: `${list} ${singular ? "was" : "were"} not added to the ${tierLabel} Prohibited Keywords list because ${
      singular ? "it is" : "they are"
    } already in the Global Prohibited Keywords list.`,
  });
}
